import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import Timestamp from "components/Timestamp";
import { makeTimestampToCopy } from "ds/components/Table/helpers";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import useCellCopyAction from "../useCellCopyAction";

const IntentProjectsTableLastResourcesUpdatedAtCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  const isEmpty = !intentProject.lastResourcesUpdatedAt;

  const copyAction = useCellCopyAction({
    text: makeTimestampToCopy(intentProject.lastResourcesUpdatedAt || 0),
  });

  const actions = useMemo(() => (isEmpty ? undefined : [copyAction]), [copyAction, isEmpty]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}
      {intentProject.lastResourcesUpdatedAt && (
        <Timestamp timestamp={intentProject.lastResourcesUpdatedAt} />
      )}
    </TableSimpleCell>
  );
};

export default IntentProjectsTableLastResourcesUpdatedAtCell;
